import * as Yup from 'yup';

export interface HoursDto {
    id?: string,
    museumId: number,
    day: string,
    open?: Date,
    close?: Date,
    isActive: boolean,
    closedAllDay: boolean
}

export const hoursInit: HoursDto = {
    id: '',
    museumId: 0,
    day: '',
    // open: new Date(),
    // close: new Date(),
    isActive: true,
    closedAllDay: false
}

export const hoursValidationSchema = Yup.object().shape({
    day: Yup.string().required("Please select a day."),
    open: Yup.date().when("closedAllDay", {
        is: false,
        then: Yup.date().required("Please enter a time.")
      }),
    close: Yup.date().min(
        Yup.ref("open"),
        "Must be greater than start time"
      ).when("closedAllDay", {
        is: false,
        then: Yup.date().required("Please enter a time.")
      }),
});